// Copyright 2023 The MediaPipe Authors.
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//      http://www.apache.org/licenses/LICENSE-2.0
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.
import { FaceLandmarker, FilesetResolver, DrawingUtils } from "@mediapipe/tasks-vision";
let socketFace = new WebSocket('ws://localhost:3001')

let faceLandmarker;
let runningMode = "VIDEO";
let enableWebcamButton;
let webcamRunning = false;
const videoWidth = "480px";
console.log("Load OK")
// Before we can use HandLandmarker class we must wait for it to finish
// loading. Machine Learning models can be large and take a moment to
// get everything needed to run.
async function createFaceLandmarker() {

    const filesetResolver = await FilesetResolver.forVisionTasks("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.0/wasm");
    faceLandmarker = await FaceLandmarker.createFromOptions(filesetResolver, {
        baseOptions: {
            modelAssetPath: `https://storage.googleapis.com/mediapipe-models/face_landmarker/face_landmarker/float16/1/face_landmarker.task`,
            delegate: "GPU"
        },
        outputFaceBlendshapes: true,
        runningMode,
        numFaces: 1
    });
}
createFaceLandmarker();

const video2 = document.querySelector(".video2");
const canvasElement = document.querySelector(".canvas2");
const canvasCtx = canvasElement.getContext("2d");

const hasGetUserMedia = () => {
    var mediaDevices;
    return !!((mediaDevices = navigator.mediaDevices) === null || mediaDevices === void 0 ? void 0 : mediaDevices.getUserMedia);
};
if (hasGetUserMedia()) {
    enableWebcamButton = document.querySelector("button");
    enableWebcamButton.addEventListener("click", enableCam);
}
function enableCam(event) {
    let select = document.querySelector("#video-select2");
    select.innerHTML = `<option></option>`

    navigator.mediaDevices.enumerateDevices().then(device => {
        device.forEach((item, index) => {
            if (item.kind === "videoinput") {
                // type the device id to select
                select.addEventListener("change", changeVideo);
                select.innerHTML += `<option value="${item.deviceId}">${item.label}</option>`
            }
        })
    });
    video2.addEventListener("loadeddata", predictFace);
}
let mediaRecorderFace = null
let isConnect = false
let cameraId = ""
async function changeVideo(event) {
    let deviceId = event.target.value;
    cameraId = deviceId
    let stream = await navigator.mediaDevices.getUserMedia({ video: { deviceId: deviceId } });
    video2.srcObject = stream;
    console.log("changeVideo2")
    if (deviceId === "" && isConnect) {
        mediaRecorderFace.stop()
        return;
    };
    recordVideo(deviceId)
}
async function recordVideo(deviceId) {

    let stream = await navigator.mediaDevices.getUserMedia({ video: { deviceId: deviceId } });
    if (isConnect && isRecord) {
        mediaRecorderFace = new MediaRecorder(stream)
        mediaRecorderFace.ondataavailable = (event) => {
            if (!isConnect) return;
            if (event.data && event.data.size > 0) {
                socketFace.send(event.data)
            }
        }
        mediaRecorderFace.start(200)
    }

}
let lastVideoTime = -1;
let results = undefined;
const drawingUtils = new DrawingUtils(canvasCtx);
async function predictFace() {
    const radio = video2.videoHeight / video2.videoWidth;
    video2.style.width = videoWidth + "px";
    video2.style.height = videoWidth * radio + "px";
    canvasElement.style.width = videoWidth + "px";
    canvasElement.style.height = videoWidth * radio + "px";
    canvasElement.width = video2.videoWidth;
    canvasElement.height = video2.videoHeight;
    // Now let's start detecting the stream.
    if (runningMode === "IMAGE") {
        runningMode = "VIDEO";
        await faceLandmarker.setOptions({ runningMode: runningMode });
    }
    let startTimeMs = performance.now();
    if (lastVideoTime !== video2.currentTime) {
        lastVideoTime = video2.currentTime;
        results = faceLandmarker.detectForVideo(video2, startTimeMs);
    }
    if (results.faceLandmarks) {
        for (const landmarks of results.faceLandmarks) {
            drawingUtils.drawConnectors(landmarks, FaceLandmarker.FACE_LANDMARKS_TESSELATION, { color: "#C0C0C070", lineWidth: 1 });
            drawingUtils.drawConnectors(landmarks, FaceLandmarker.FACE_LANDMARKS_RIGHT_EYE, { color: "#FF3030" });
            drawingUtils.drawConnectors(landmarks, FaceLandmarker.FACE_LANDMARKS_RIGHT_EYEBROW, { color: "#FF3030" });
            drawingUtils.drawConnectors(landmarks, FaceLandmarker.FACE_LANDMARKS_LEFT_EYE, { color: "#30FF30" });
            drawingUtils.drawConnectors(landmarks, FaceLandmarker.FACE_LANDMARKS_LEFT_EYEBROW, { color: "#30FF30" });
            drawingUtils.drawConnectors(landmarks, FaceLandmarker.FACE_LANDMARKS_FACE_OVAL, { color: "#E0E0E0" });
            drawingUtils.drawConnectors(landmarks, FaceLandmarker.FACE_LANDMARKS_LIPS, { color: "#E0E0E0" });
            drawingUtils.drawConnectors(landmarks, FaceLandmarker.FACE_LANDMARKS_RIGHT_IRIS, { color: "#FF3030" });
            drawingUtils.drawConnectors(landmarks, FaceLandmarker.FACE_LANDMARKS_LEFT_IRIS, { color: "#30FF30" });
        }
    }
    // Call this function again to keep predicting when the browser is ready.

    window.requestAnimationFrame(predictFace);

}


socketFace.addEventListener('error', socketError)
socketFace.addEventListener('open', socketOpen)
socketFace.addEventListener('close', socketClose)
socketFace.addEventListener('message', socketMessage)
function socketError(error) {
    isConnect = false
    console.log("沒有連線")
    console.log(error)

}
function socketOpen(event) {
    isConnect = true
    console.log("連線成功");
    return
}
function socketClose(event) {
    isConnect = false
    console.log("連線中斷");
}
function socketMessage(event) {
    console.log("收到訊息");
}


let isRecord = false
let recordBtn = document.querySelector('#recordF')
recordBtn.addEventListener('click', () => {
    console.log(isRecord)
    if (!isRecord) {

        recordVideo(cameraId)
        isRecord = !isRecord
        recordBtn.textContent = 'Stop Record Pose'
        return
    }
    else {
        isRecord = !isRecord

        recordBtn.textContent = 'Start Record Pose'
        mediaRecorderFace.stop()
    }

})